import { IResponse, IResponsePagination, IResponseList } from '@/types/common';
import {
  ICreateCategoryRequest,
  IGetListCategoryRequest,
  IUpdateCategoryRequest,
} from '@/types/request/category';
import {
  IGetDetailCategoryResponse,
  IGetListCategoryResponse,
} from '@/types/response/category';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';

class Category {
  getList = (
    params: IGetListCategoryRequest,
  ): Promise<IResponsePagination<IGetListCategoryResponse>> => {
    return axiosClient.get(ENDPOINT.CATEGORY.GET_LIST, {
      params,
    });
  };

  getAll = (): Promise<IResponseList<IGetListCategoryResponse>> => {
    return axiosClient.get(ENDPOINT.CATEGORY.GET_ALL);
  };

  exists = (name: string): Promise<IResponse<number | null>> => {
    return axiosClient.get(ENDPOINT.CATEGORY.EXISTS, {
      params: {
        name,
      },
    });
  };

  create = (
    body: ICreateCategoryRequest,
  ): Promise<IResponse<IGetDetailCategoryResponse>> => {
    return axiosClient.post(ENDPOINT.CATEGORY.CREATE, body);
  };

  getDetail = (id: number): Promise<IResponse<IGetDetailCategoryResponse>> => {
    return axiosClient.get(
      ENDPOINT.CATEGORY.GET_DETAIL.replace(':id', String(id)),
    );
  };

  update = (
    data: IUpdateCategoryRequest,
    id: number,
  ): Promise<IResponse<IGetDetailCategoryResponse>> => {
    return axiosClient.put(
      ENDPOINT.CATEGORY.UPDATE.replace(':id', String(id)),
      data,
    );
  };

  delete = (id: number) => {
    return axiosClient.delete(
      ENDPOINT.CATEGORY.DELETE.replace(':id', String(id)),
    );
  };
}

export const CategoryService = new Category();
